import { Base } from '@studiometa/js-toolkit';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
  };

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction The direction of the scroll.
   */
  scrolled({ y, direction }) {
    if (y === 0) {
      this.$el.classList.remove('has-scrolled');
    }

    if (y > 0) {
      this.$el.classList.add('has-scrolled');
    }

    if (direction.y === 'UP') {
      this.$el.classList.add('header--up');
    }

    if (direction.y === 'DOWN') {
      this.$el.classList.remove('header--up');
    }
  }
}
